import { render, staticRenderFns } from "./ParametricKnowledgeEditor.vue?vue&type=template&id=468c6737&scoped=true&"
import script from "./ParametricKnowledgeEditor.vue?vue&type=script&lang=js&"
export * from "./ParametricKnowledgeEditor.vue?vue&type=script&lang=js&"
import style0 from "./ParametricKnowledgeEditor.vue?vue&type=style&index=0&id=468c6737&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468c6737",
  null
  
)

export default component.exports